<script setup lang="ts">
import { onlineManager } from '@tanstack/vue-query'
import { StatusTag } from '@taler/ui'
import { onScopeDispose, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const online = ref(onlineManager.isOnline())
const unsubscribe = onlineManager.subscribe((isOnline) => {
  online.value = isOnline
})
onScopeDispose(unsubscribe)
</script>

<template>
  <div v-if="!online" role="status" class="px-[var(--space-block)] pt-[var(--space-inline)]">
    <StatusTag tone="neutral" size="md">{{ t('shell.offline') }}</StatusTag>
  </div>
</template>
